import React from 'react';

export default function RolesText(props) {
    return (
        <td>{props.user.roles.map(props.getRoleAlias).join(', ')}</td>
    )
}
